import script from "./base-detail-popup.vue?vue&type=script&lang=js"
export * from "./base-detail-popup.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__